/* eslint-disable max-len */
import React from 'react';
import PreloaderImage from './assets/preloader.gif';
import MicrosoftLogo from './assets/microsoft-logo.png';
import XaraLogoGif from './assets/xara-logo.gif';

import NoPackageImage from './assets/nopackage.png';

import WeAcceptImage from './assets/we-accept.png';
import WeAcceptEurImage from './assets/we-accept-eur.png';

import ScaleImage from './assets/scale.png';
import EssentialImage from './assets/essential.png';

import WDImage from './assets/wd_plus.png';
import DPImage from './assets/dp_plus.png';
import PGDImage from './assets/pgd_plus.png';

import WDPerpetualImage from './assets/wd_perpetual.png';
import DPPerpetualImage from './assets/dp_perpetual.png';
import PGDPerpetualImage from './assets/pgd_perpetual.png';

import AddonAI from './assets/addon-ai.png';
import AddonCloudStorage from './assets/addon-cloud-storage.png';
import AddonDesignServices from './assets/addon-design-services.png';
import AddonMLS from './assets/addon-mls.png';
import AddonHosting from './assets/addon-hosting.png';

export const XaraLogo = props => {
	return (
		<svg version="1.1" viewBox="0 0 445.88 162.16" width="445.88" height="162.16" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g fill="currentColor">
				<path
					transform="translate(-18.87 -31.7)"
					d="M338.63,31.7H313.38C297,31.7,284.21,45,284.21,61.82v90.35a7.11,7.11,0,1,0,14.21,0V61.82c0-8.67,6.59-15.45,15-15.45h25.25a7.34,7.34,0,0,0,0-14.67Z"
				/>
				<path
					transform="translate(-18.87 -31.7)"
					d="m230.2 144.86h-51.31c-8.36 0-15-6.81-15-15.47v-16.29a15.25 15.25 0 0 1 15-15.47h72.65v25.22c0 12.15-9.54 22.01-21.34 22.01zm6.34-113.16h-53.69c-16.37 0-29.2 13.25-29.2 30.12a7.12 7.12 0 1 0 14.23 0c0-8.67 6.57-15.45 15-15.45h53.69c8.4 0 15 6.78 15 15.45v21.18h-72.68c-16.06 0-29.18 13.5-29.18 30.12v16.29c0 16.87 12.83 30.1 29.18 30.1h51.31a34.75 34.75 0 0 0 21.34-7.33 7.1 7.1 0 1 0 14.19 0v-90.36c0-16.82-12.83-30.12-29.19-30.12z"
				/>
				<path
					transform="translate(-18.87 -31.7)"
					d="M429.24,144.86H378c-8.4,0-15-6.81-15-15.47V113.1a15.25,15.25,0,0,1,15-15.47h72.6v25.22C450.56,135,441,144.86,429.24,144.86ZM435.56,31.7H381.89c-16.37,0-29.2,13.25-29.2,30.12a7.1,7.1,0,1,0,14.19,0,15.08,15.08,0,0,1,15-15.45h53.67c8.4,0,15,6.78,15,15.45V83H378c-16.13,0-29.22,13.5-29.22,30.12v16.29c0,16.87,12.83,30.1,29.22,30.1h51.28a34.6,34.6,0,0,0,21.32-7.33h0a7.1,7.1,0,1,0,14.19,0V61.82C464.75,45,451.92,31.7,435.56,31.7Z"
				/>
				<path
					transform="translate(-18.87 -31.7)"
					d="m140.44 34.1a7.54 7.54 0 0 0-5.44-2.36 7.56 7.56 0 0 0-5.46 2.35l-48.74 50.2-48.7-50.19a7.63 7.63 0 0 0-5.47-2.36 7.58 7.58 0 0 0-5.49 2.36 8.19 8.19 0 0 0 0 11.29l108.38 111.76a7.52 7.52 0 0 0 5.47 2.31 7.31 7.31 0 0 0 5.45-2.31 8.19 8.19 0 0 0 0-11.31l-48.65-50.23 48.65-50.22a8.15 8.15 0 0 0 0-11.29z"
				/>
				<path
					transform="translate(-18.87 -31.7)"
					d="m21 157.24a7 7 0 0 0 5.23 2.22 7.16 7.16 0 0 0 5.19-2.22l26-26.82-10.42-10.75-26 26.83a7.79 7.79 0 0 0 0 10.74z"
				/>
			</g>
		</svg>
	);
};

export const PreloaderIcon = props => {
	return (
		<img alt='Xara for Teams' src={PreloaderImage} {...props} />
	);
};

export const MicrosoftIcon = props => {
	return (
		<img alt='Microsoft' src={MicrosoftLogo} {...props} />
	);
};

export const XaraLogoAnimated = props => {
	return (
		<img alt='Xara' src={XaraLogoGif} {...props} />
	);
};

export const AccountIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" {...props}>
			<g transform="translate(-375 -1711)">
				<g fill="none" stroke="currentColor" transform="translate(389.873 1717)">
					<circle stroke="none" cx="9.921" cy="9.921" r="9.921" />
					<circle fill="none" cx="9.921" cy="9.921" r="9.421" />
				</g>
				<g fill="none" transform="translate(-1690 607)">
					<path
						stroke="none"
						d="M2074,1148.21v-.448c0-.1,0-.207.01-.311.291-8.863,7.247-15.957,15.784-15.957s15.494,7.093,15.784,15.957c.006.1.01.206.01.311v.784a25,25,0,0,1-31.588-.336Z"
					/>
					<path
						fill="currentColor"
						d="M 2089.999755859375 1152.999877929688 C 2092.7685546875 1152.999877929688 2095.482421875 1152.532592773438 2098.0654296875 1151.611083984375 C 2100.412841796875 1150.773681640625 2102.604736328125 1149.579711914063 2104.587890625 1148.05908203125 L 2104.587890625 1147.761962890625 C 2104.587890625 1147.682861328125 2104.585205078125 1147.601440429688 2104.579833984375 1147.513061523438 L 2104.578857421875 1147.498657226563 L 2104.578369140625 1147.484130859375 C 2104.446044921875 1143.442260742188 2102.843505859375 1139.666015625 2100.06640625 1136.851196289063 C 2097.294677734375 1134.041625976563 2093.646484375 1132.494384765625 2089.793701171875 1132.494384765625 C 2085.941162109375 1132.494384765625 2082.29296875 1134.041748046875 2079.52099609375 1136.8515625 C 2076.743896484375 1139.66650390625 2075.1416015625 1143.442626953125 2075.009033203125 1147.484252929688 L 2075.008544921875 1147.498413085938 L 2075.007568359375 1147.5126953125 C 2075.0029296875 1147.589965820313 2075.000244140625 1147.663330078125 2074.999755859375 1147.736083984375 C 2077.01953125 1149.355590820313 2079.267822265625 1150.62841796875 2081.689697265625 1151.522338867188 C 2084.345703125 1152.502807617188 2087.1416015625 1152.999877929688 2089.999755859375 1152.999877929688 M 2089.999755859375 1153.999877929688 C 2083.913818359375 1153.999877929688 2078.335205078125 1151.82470703125 2073.999755859375 1148.2099609375 L 2073.999755859375 1148.029174804688 L 2073.999755859375 1147.761962890625 C 2073.999755859375 1147.657470703125 2074.003173828125 1147.554931640625 2074.009521484375 1147.451416015625 C 2074.30029296875 1138.588256835938 2081.25634765625 1131.494384765625 2089.793701171875 1131.494384765625 C 2098.3310546875 1131.494384765625 2105.287353515625 1138.587280273438 2105.577880859375 1147.451416015625 C 2105.584228515625 1147.554077148438 2105.587890625 1147.657470703125 2105.587890625 1147.761962890625 L 2105.587890625 1148.546264648438 C 2101.313720703125 1151.959106445313 2095.89453125 1153.999877929688 2089.999755859375 1153.999877929688 Z"
					/>
				</g>
				<g fill="none" stroke="currentColor" transform="translate(375 1711)">
					<circle stroke="none" cx="25" cy="25" r="25" />
					<circle fill="none" cx="25" cy="25" r="24.5" />
				</g>
			</g>
		</svg>
	);
};

export const CupIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21.078" height="20" viewBox="0 0 21.078 20" {...props}>
			<g transform="translate(-2.8 -8.3)">
				<path
					fill="currentColor"
					d="M91.765,60.629a.56.56,0,0,0-.276-.151l-1.841-.268-.82-1.657a.641.641,0,0,0-.326-.268.569.569,0,0,0-.452.042.648.648,0,0,0-.234.218L87,60.21l-1.8.259-.033.008a.611.611,0,0,0-.326.2l-.033.042a.59.59,0,0,0-.092.427.635.635,0,0,0,.159.318l1.305,1.272-.31,1.824a.608.608,0,0,0,.1.393L86,65a.592.592,0,0,0,.351.2.376.376,0,0,0,.092.008.521.521,0,0,0,.259-.067l1.607-.845,1.632.862a.558.558,0,0,0,.418.017.608.608,0,0,0,.351-.31.69.69,0,0,0,.05-.335l-.31-1.791,1.322-1.289a.579.579,0,0,0,.151-.393v-.042A.5.5,0,0,0,91.765,60.629Zm-2.184,1.816.3,1.732-1.557-.82-1.557.82.293-1.732-1.255-1.23,1.741-.251.778-1.573.778,1.573,1.741.251Z"
					transform="translate(-74.983 -45.82)"
				/>
				<path
					fill="currentColor"
					d="M22.851,11.591H20.4V10.049a.751.751,0,0,0-.749-.749H7.036a.751.751,0,0,0-.749.749v1.541H3.836A1.035,1.035,0,0,0,2.8,12.626v2.139a4.59,4.59,0,0,0,3.756,4.514,6.909,6.909,0,0,0,1.491,2.888,7.018,7.018,0,0,0,3.276,2.088l-1.3,2.8h-.008a.757.757,0,0,0-.758.766V29.3h8.16V27.818a.755.755,0,0,0-.758-.758l-1.305-2.8a7.018,7.018,0,0,0,3.276-2.088,6.909,6.909,0,0,0,1.491-2.888,4.582,4.582,0,0,0,3.756-4.514V12.626A1.023,1.023,0,0,0,22.851,11.591ZM3.634,14.765V12.626a.208.208,0,0,1,.211-.211H6.295v4.556a9.992,9.992,0,0,0,.1,1.415A3.755,3.755,0,0,1,3.634,14.765Zm15.781,3.891a6.116,6.116,0,0,1-1.4,2.956,6.235,6.235,0,0,1-3.074,1.895l-.758.194,1.945,4.185h.463v.581h-6.5v-.581h.463L12.5,23.7l-.749-.194a6.235,6.235,0,0,1-3.074-1.895,6.153,6.153,0,0,1-1.4-2.956,9.355,9.355,0,0,1-.16-1.684V10.125H19.566v6.846A9.281,9.281,0,0,1,19.415,18.656Zm3.638-3.891A3.767,3.767,0,0,1,20.3,18.386a9.816,9.816,0,0,0,.1-1.415V12.416h2.451a.208.208,0,0,1,.211.211v2.139Z"
					transform="translate(0 -1)"
				/>
			</g>
		</svg>
	);
};

export const UsersIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22.521" height="20" viewBox="0 0 22.521 20" {...props}>
			<g transform="translate(-1.6 -15.8)">
				<path
					fill="currentColor"
					d="M105.16,20.12A2.16,2.16,0,1,0,103,17.96,2.161,2.161,0,0,0,105.16,20.12Zm0-3.439a1.279,1.279,0,1,1-1.279,1.279A1.281,1.281,0,0,1,105.16,16.681Z"
					transform="translate(-92.299)"
				/>
				<path
					fill="currentColor"
					d="M7.82,84.72a.433.433,0,0,0-.328.4l-.328,5.054a.364.364,0,0,1-.372.346H4.287a.37.37,0,0,1-.372-.346l-.337-5.046a.434.434,0,0,0-.311-.389,1.537,1.537,0,0,1-.415-.164,2.079,2.079,0,0,1-.06-.484l-.3-5.348h0c.432-.13,1.14-.354,1.512-.475l1.235,1.158a.45.45,0,0,0,.6,0l1.235-1.158c.121.035.268.086.432.138a.44.44,0,0,0,.268-.838c-.372-.121-.674-.216-.674-.216a.455.455,0,0,0-.441.1L5.54,78.5,4.416,77.446a.435.435,0,0,0-.441-.1s-1.184.38-1.78.562a.8.8,0,0,0-.6.795v.1h0l.294,5.27a.424.424,0,0,0,.009.1c.052.778.164,1.063.812,1.313l.311,4.752a1.263,1.263,0,0,0,1.253,1.175H6.784a1.263,1.263,0,0,0,1.253-1.175l.32-4.925a.458.458,0,0,0,.009-.285A.443.443,0,0,0,7.82,84.72Z"
					transform="translate(0 -55.607)"
				/>
				<path
					fill="currentColor"
					d="M24.26,23.62a2.16,2.16,0,1,0-2.16-2.16A2.161,2.161,0,0,0,24.26,23.62Zm0-3.43a1.279,1.279,0,1,1-1.279,1.279A1.281,1.281,0,0,1,24.26,20.19Z"
					transform="translate(-18.729 -3.198)"
				/>
				<path
					fill="currentColor"
					d="M89.683,77.712c-.6-.181-1.78-.562-1.78-.562a.455.455,0,0,0-.441.1L86.34,78.3l-1.123-1.054a.435.435,0,0,0-.441-.1s-1.184.38-1.78.562a.788.788,0,0,0-.6.795l.294,5.382.009.086c.052.778.164,1.071.812,1.313l.311,4.752a1.263,1.263,0,0,0,1.253,1.175h2.514a1.263,1.263,0,0,0,1.253-1.175l.311-4.752c.648-.251.76-.544.812-1.313l.3-5.391v-.078A.766.766,0,0,0,89.683,77.712ZM89.1,83.821l-.009.086a1.977,1.977,0,0,1-.06.467,1.6,1.6,0,0,1-.423.164.436.436,0,0,0-.311.4l-.328,5.046a.364.364,0,0,1-.371.346H85.078a.376.376,0,0,1-.371-.346l-.328-5.046a.455.455,0,0,0-.311-.4,1.537,1.537,0,0,1-.415-.164,2.045,2.045,0,0,1-.06-.467l-.3-5.348v-.026c.432-.13,1.14-.354,1.512-.475l1.235,1.158a.45.45,0,0,0,.6,0l1.235-1.149c.372.121,1.08.346,1.512.475Z"
					transform="translate(-73.479 -55.425)"
				/>
				<path
					fill="currentColor"
					d="M181.98,77.712c-.6-.181-1.78-.562-1.78-.562a.455.455,0,0,0-.441.1L178.637,78.3l-1.123-1.054a.435.435,0,0,0-.441-.1s-.3.1-.674.216a.44.44,0,1,0,.268.838c.164-.052.311-.1.432-.138l1.235,1.158a.45.45,0,0,0,.6,0l1.235-1.158c.372.121,1.071.337,1.512.475l-.294,5.279-.009.086a1.976,1.976,0,0,1-.06.467,1.6,1.6,0,0,1-.423.164.436.436,0,0,0-.311.4l-.328,5.046a.375.375,0,0,1-.372.346h-2.514a.382.382,0,0,1-.371-.346l-.337-5.046a.473.473,0,0,0-.328-.4.427.427,0,0,0-.544.285.442.442,0,0,0,0,.259l.328,4.959a1.257,1.257,0,0,0,1.253,1.175h2.514a1.263,1.263,0,0,0,1.253-1.175l.311-4.752c.648-.251.76-.536.812-1.3,0-.035.009-.112.009-.112l.294-5.3V78.5A.787.787,0,0,0,181.98,77.712Z"
					transform="translate(-158.447 -55.425)"
				/>
				<path
					fill="currentColor"
					d="M186.06,23.62a2.16,2.16,0,1,0-2.16-2.16A2.161,2.161,0,0,0,186.06,23.62Zm0-3.43a1.279,1.279,0,1,1-1.279,1.279A1.281,1.281,0,0,1,186.06,20.19Z"
					transform="translate(-165.87 -3.198)"
				/>
			</g>
		</svg>
	);
};

export const MoneyBoxIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20.769" height="20" viewBox="0 0 20.769 20" {...props}>
			<g transform="translate(-7 -11.214)">
				<path
					fill="currentColor"
					d="M182.124,13.367a3.6,3.6,0,0,0-1.982-1.9,3.545,3.545,0,0,0-2.746.06,3.586,3.586,0,0,0-1.1.755.425.425,0,0,0,.6.6,2.714,2.714,0,0,1,.841-.575,2.747,2.747,0,0,1,2.214,5.028,2.857,2.857,0,0,1-1,.232.425.425,0,0,0,.017.85h.017a3.583,3.583,0,0,0,3.132-5.046Z"
					transform="translate(-154.658)"
				/>
				<path
					fill="currentColor"
					d="M118.4,39.755a3.628,3.628,0,0,0,1.3.249,3.543,3.543,0,0,0,1.442-.309,3.6,3.6,0,0,0,1.9-1.982,3.545,3.545,0,0,0-.06-2.746,3.6,3.6,0,0,0-1.982-1.9,3.545,3.545,0,0,0-2.746.06h0a3.6,3.6,0,0,0-1.9,1.982,3.6,3.6,0,0,0,2.042,4.651Zm-1.253-4.342a2.737,2.737,0,0,1,1.45-1.519h0a2.744,2.744,0,0,1,1.1-.232,2.663,2.663,0,0,1,1,.189,2.744,2.744,0,1,1-3.51,3.664A2.786,2.786,0,0,1,117.151,35.413Z"
					transform="translate(-99.751 -19.747)"
				/>
				<path
					fill="currentColor"
					d="M79.142,72.011a.4.4,0,0,0,.146-.026,7.306,7.306,0,0,1,1.545-.4.421.421,0,0,0-.129-.832,8.562,8.562,0,0,0-1.716.446.43.43,0,0,0-.249.541A.448.448,0,0,0,79.142,72.011Z"
					transform="translate(-65.561 -54.436)"
				/>
				<path
					fill="currentColor"
					d="M24.565,81.762a6.284,6.284,0,0,0-.858-1.879.421.421,0,0,0-.7.463,5.587,5.587,0,0,1,.747,1.63,4.486,4.486,0,0,1,.1.463,5.562,5.562,0,0,1-1.467,4.848,1.187,1.187,0,0,0-.3.532L21.3,90.549H19.528l-.206-.807a.423.423,0,0,0-.412-.317l-4.522-.017h0a.43.43,0,0,0-.412.318l-.215.824H12L11.5,88.765a1.281,1.281,0,0,0-.7-.807,15.38,15.38,0,0,1-2.849-1.673.289.289,0,0,1-.112-.232l.009-3.338.455-.009a.445.445,0,0,0,.335-.172l1.811-2.4c.009-.017.026-.034.034-.051a.581.581,0,0,0-.051-.566c-.017-.051-.043-.1-.06-.154l-.034-.077c-.069-.163-.146-.326-.223-.481-.137-.292-.292-.584-.446-.867-.017-.034-.034-.06-.051-.094h.12a3.5,3.5,0,0,1,1.184.189c.1.034.317.137.369.163a.008.008,0,0,1,.009.009c.077.043.532.309.635.386a3.737,3.737,0,0,1,1.1,1.321.422.422,0,0,0,.755-.378A4.648,4.648,0,0,0,12.44,77.91c-.146-.112-.592-.369-.712-.438a2.118,2.118,0,0,0-.532-.24A4.239,4.239,0,0,0,9.772,77c-.1,0-.206,0-.292.009l-.163.009a.109.109,0,0,0-.051.009h0c-.017,0-.034.009-.051.009a.726.726,0,0,0-.506.429A.735.735,0,0,0,8.751,78a1.24,1.24,0,0,0,.129.266c0,.009.017.026.026.034l.026.043c.146.275.292.549.429.832.069.154.146.3.206.446L9.6,79.7a.6.6,0,0,1,.043.112L8.1,81.865l-.669.009a.414.414,0,0,0-.412.42L7,86.062a1.134,1.134,0,0,0,.446.91,16.113,16.113,0,0,0,3.012,1.776.408.408,0,0,1,.223.266l.6,2.085a.422.422,0,0,0,.4.309H14.1a.43.43,0,0,0,.412-.317l.215-.824,3.861.017.206.807a.423.423,0,0,0,.412.317h2.42a.422.422,0,0,0,.4-.309l.884-3.055a.4.4,0,0,1,.086-.154,6.417,6.417,0,0,0,1.7-5.586Q24.643,82.033,24.565,81.762Z"
					transform="translate(0 -60.193)"
				/>
				<path
					fill="currentColor"
					d="M49.656,129.278a.678.678,0,1,1-.678-.678A.685.685,0,0,1,49.656,129.278Z"
					transform="translate(-37.756 -107.341)"
				/>
			</g>
		</svg>
	);
};

export const DeleteIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
			<g transform="translate(-267 -1000)">
				<g fill="none" stroke="currentColor" transform="translate(267 1000)">
					<circle stroke="none" cx="10" cy="10" r="10" />
					<circle fill="none" cx="10" cy="10" r="9.5" />
				</g>
				<line stroke="currentColor" strokeLinecap="round" x1="9.182" transform="translate(273.507 1013.186) rotate(-45)" />
				<line stroke="currentColor" strokeLinecap="round" x1="9.182" transform="translate(273.507 1006.693) rotate(45)" />
			</g>
		</svg>
	);
};

export const Info = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
			<g transform="translate(-690 -220)">
				<circle fill="none" cx="10" cy="10" r="10" transform="translate(690 220)" />
				<path fill="currentColor" d="M1.148,6.008q0-1.164,1.3-1.164t1.3,1.164a1.135,1.135,0,0,1-.324.863,1.363,1.363,0,0,1-.973.309Q1.148,7.18,1.148,6.008ZM3.633,17H1.25V8.266H3.633Z" transform="translate(698 219)" />
			</g>
		</svg>
	);
};

export const GoBackIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" {...props}>
			<g transform="translate(-285 -105)">
				<g fill="none" stroke="currentColor" strokeWidth="1.5px" transform="translate(285 105)">
					<circle stroke="none" cx="13.5" cy="13.5" r="13.5" />
					<circle fill="none" cx="13.5" cy="13.5" r="12.75" />
				</g>
				<g transform="translate(292 112)">
					<line fill="none" stroke="currentColor" strokeWidth="1.5px" strokeLinecap="round" x2="13.471" transform="translate(0 6.041)" />
					<line fill="none" stroke="currentColor" strokeWidth="1.5px" strokeLinecap="round" y1="6.041" x2="6.385" transform="translate(0 0)" />
					<line fill="none" stroke="currentColor" strokeWidth="1.5px" strokeLinecap="round" x2="6.385" y2="6.041" transform="translate(0 6.049)" />
				</g>
			</g>
		</svg>
	);
};

export const FolderIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21.083" height="17.363" viewBox="0 0 21.083 17.363" {...props}>
			<g transform="translate(-2056 -1110)" fill="none">
				<path
					d="M2058,1127.363a2,2,0,0,1-2-2V1112a2,2,0,0,1,2-2h5.921a2,2,0,0,1,2,2v1.72h9.162a2,2,0,0,1,2,2v9.642a2,2,0,0,1-2,2Z"
					stroke="none"
				/>
				<path
					d="M 2075.083251953125 1126.5625 C 2075.744873046875 1126.5625 2076.282958984375 1126.024291992188 2076.282958984375 1125.362670898438 L 2076.282958984375 1115.721069335938 C 2076.282958984375 1115.058959960938 2075.744873046875 1114.520385742188 2075.083251953125 1114.520385742188 L 2065.921142578125 1114.520385742188 L 2065.12109375 1114.520385742188 L 2065.12109375 1113.720336914063 L 2065.12109375 1112.000366210938 C 2065.12109375 1111.33837890625 2064.5830078125 1110.7998046875 2063.92138671875 1110.7998046875 L 2058.000244140625 1110.7998046875 C 2057.33837890625 1110.7998046875 2056.7998046875 1111.33837890625 2056.7998046875 1112.000366210938 L 2056.7998046875 1115.721069335938 L 2056.7998046875 1125.362670898438 C 2056.7998046875 1126.024291992188 2057.33837890625 1126.5625 2058.000244140625 1126.5625 L 2075.083251953125 1126.5625 M 2075.083251953125 1127.362548828125 L 2058.000244140625 1127.362548828125 C 2056.895263671875 1127.362548828125 2055.999755859375 1126.467041015625 2055.999755859375 1125.362670898438 L 2055.999755859375 1115.721069335938 L 2055.999755859375 1112.000366210938 C 2055.999755859375 1110.895263671875 2056.895263671875 1109.999755859375 2058.000244140625 1109.999755859375 L 2063.92138671875 1109.999755859375 C 2065.025634765625 1109.999755859375 2065.921142578125 1110.895263671875 2065.921142578125 1112.000366210938 L 2065.921142578125 1113.720336914063 L 2075.083251953125 1113.720336914063 C 2076.1875 1113.720336914063 2077.0830078125 1114.615844726563 2077.0830078125 1115.721069335938 L 2077.0830078125 1125.362670898438 C 2077.0830078125 1126.467041015625 2076.1875 1127.362548828125 2075.083251953125 1127.362548828125 Z"
					stroke="none"
					fill="currentColor"
				/>
			</g>
		</svg>
	);
};

export const ProtectBrandIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="29.29" height="29.29" viewBox="0 0 52.008 52.687" {...props}>
			<g id="protect_brand" transform="translate(-52.995 -270.5)">
				<path id="Path_586" data-name="Path 586" d="M54,277.5c9.479-.177,17.58-3.146,25-6,7.693,3.122,16.05,5.733,25,6,0,38-25,44.687-25,44.687S53.5,315.5,54,277.5Z" fill="none" stroke="#282828" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
				<path id="Path_587" data-name="Path 587" d="M70,292.5l7,8,11-15" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
			</g>
		</svg>
	);
};

export const TeamIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="37.37" height="37.37" viewBox="0 0 64.646 51.677" {...props}>
			<g id="team_icon" transform="translate(-211.177 -271)">
				<circle id="Ellipse_126" data-name="Ellipse 126" cx="6.21" cy="6.21" r="6.21" transform="translate(259.613 272)" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" />
				<path id="Path_591" data-name="Path 591" d="M269.823,288.145l-4,3.726-4-3.726-5,2.484,1,19.871a26.386,26.386,0,0,0,16,0l1-19.871Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
				<circle id="Ellipse_127" data-name="Ellipse 127" cx="6.21" cy="6.21" r="6.21" transform="translate(214.968 272)" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" />
				<path id="Path_592" data-name="Path 592" d="M225.177,288.145l-4,3.726-4-3.726-5,2.484,1,19.871a26.386,26.386,0,0,0,16,0l1-19.871Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
				<path id="Path_593" data-name="Path 593" d="M247.5,298.081l-4,3.725-4-3.725-5,2.484,1,19.87a26.386,26.386,0,0,0,16,0l1-19.87Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
				<circle id="Ellipse_128" data-name="Ellipse 128" cx="6.21" cy="6.21" r="6.21" transform="translate(237.29 281.935)" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" />
			</g>
		</svg>
	);
};

export const SaveTimeIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 52 52" {...props}>
			<g id="save_time" transform="translate(-296 -271)">
				<circle id="Ellipse_129" data-name="Ellipse 129" cx="25" cy="25" r="25" transform="translate(297 272)" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
				<path id="Path_594" data-name="Path 594" d="M322,283v14l17,9" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
			</g>
		</svg>
	);
};

export const UpdatedIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="33.96" height="27.73" viewBox="0 0 68 57.139" {...props}>
			<g id="updated_icon" transform="translate(-460 -268.671)">
				<rect id="Rectangle_233" data-name="Rectangle 233" width="61.405" height="50.127" rx="5.901" transform="translate(463.506 272.177)" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" strokeDasharray="5" />
				<circle id="Ellipse_130" data-name="Ellipse 130" cx="2.297" cy="2.297" r="2.297" transform="translate(461 295.152)" fill="#fff" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
				<circle id="Ellipse_131" data-name="Ellipse 131" cx="2.297" cy="2.297" r="2.297" transform="translate(522.405 295.152)" fill="#fff" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
				<circle id="Ellipse_132" data-name="Ellipse 132" cx="2.297" cy="2.297" r="2.297" transform="translate(491.911 269.671)" fill="#fff" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
				<circle id="Ellipse_133" data-name="Ellipse 133" cx="2.297" cy="2.297" r="2.297" transform="translate(491.911 320.215)" fill="#fff" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
				<rect id="Rectangle_234" data-name="Rectangle 234" width="8.772" height="21.722" rx="2.604" transform="translate(476.873 289.722)" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
				<rect id="Rectangle_235" data-name="Rectangle 235" width="8.772" height="27.57" rx="2.624" transform="translate(489.405 283.873)" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
				<rect id="Rectangle_236" data-name="Rectangle 236" width="8.772" height="32.165" rx="2.612" transform="translate(501.937 279.278)" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
			</g>
		</svg>
	);
};

export const SubscriptionIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="206.955" height="199.29" viewBox="0 0 206.955 199.29" {...props}>
			<g transform="translate(-7 -11.214)">
				<path fill="rgba(47,165,231,0.3)" d="M235.452,32.664A35.833,35.833,0,0,0,215.7,13.682a35.323,35.323,0,0,0-27.362.6A35.733,35.733,0,0,0,177.393,21.8a4.232,4.232,0,1,0,5.985,5.985,27.043,27.043,0,0,1,8.379-5.729,27.374,27.374,0,0,1,22.061,50.106,28.471,28.471,0,0,1-9.919,2.309,4.235,4.235,0,0,0,.171,8.465h.171a36.442,36.442,0,0,0,13-2.993A36.1,36.1,0,0,0,235.452,32.664Z" transform="translate(-24.522 0)" />
				<path fill="rgba(47,165,231,0.3)" d="M138.932,101.976a36.152,36.152,0,0,0,13,2.48,35.3,35.3,0,0,0,14.365-3.078,35.834,35.834,0,0,0,18.982-19.752,35.323,35.323,0,0,0-.6-27.362,35.834,35.834,0,0,0-19.752-18.982,35.323,35.323,0,0,0-27.362.6h0a35.834,35.834,0,0,0-18.982,19.752,35.862,35.862,0,0,0,20.35,46.344ZM126.448,58.71A27.276,27.276,0,0,1,140.9,43.576h0a27.344,27.344,0,0,1,10.944-2.309,26.537,26.537,0,0,1,9.919,1.881A27.343,27.343,0,1,1,126.79,79.659,27.762,27.762,0,0,1,126.448,58.71Z" transform="translate(-15.816 -3.131)" />
				<path fill="rgba(47,165,231,0.3)" d="M82.977,83.361a3.993,3.993,0,0,0,1.454-.257,72.8,72.8,0,0,1,15.391-4.019,4.2,4.2,0,0,0-1.283-8.294,85.317,85.317,0,0,0-17.1,4.446,4.285,4.285,0,0,0-2.48,5.387A4.463,4.463,0,0,0,82.977,83.361Z" transform="translate(-10.395 -8.771)" />
				<path fill="rgba(47,165,231,0.3)" d="M182.029,124.455a62.615,62.615,0,0,0-8.551-18.726,4.2,4.2,0,0,0-7.011,4.617,55.668,55.668,0,0,1,7.439,16.246,44.71,44.71,0,0,1,1.026,4.617c3.164,17.614-2.48,36.083-14.621,48.31a11.828,11.828,0,0,0-2.993,5.3l-7.866,27.191H131.838l-2.052-8.038a4.211,4.211,0,0,0-4.1-3.164l-45.061-.171h0a4.286,4.286,0,0,0-4.1,3.164l-2.138,8.208H56.85L51.8,194.228a12.76,12.76,0,0,0-6.926-8.037,153.253,153.253,0,0,1-28.388-16.674,2.878,2.878,0,0,1-1.112-2.309l.086-33.261L20,133.861a4.431,4.431,0,0,0,3.335-1.71l18.042-23.941c.086-.171.257-.342.342-.513,1.112-1.967.342-3.848-.513-5.643-.171-.513-.428-1.026-.6-1.539l-.342-.769c-.684-1.625-1.454-3.249-2.223-4.788-1.368-2.907-2.907-5.814-4.446-8.636-.171-.342-.342-.6-.513-.94h1.2a34.858,34.858,0,0,1,11.8,1.881c1.026.342,3.164,1.368,3.677,1.625a.084.084,0,0,1,.085.086c.77.427,5.3,3.078,6.327,3.848A37.234,37.234,0,0,1,67.11,105.986a4.206,4.206,0,1,0,7.524-3.762A46.313,46.313,0,0,0,61.21,86.064c-1.454-1.112-5.9-3.677-7.1-4.361a21.108,21.108,0,0,0-5.3-2.394A42.242,42.242,0,0,0,34.618,77c-1.026,0-2.052,0-2.907.085l-1.625.086a1.084,1.084,0,0,0-.513.086h0c-.171,0-.342.085-.513.085a7.23,7.23,0,0,0-5.045,4.275c-.855,2.223.086,4.361.428,5.3a12.354,12.354,0,0,0,1.283,2.651c0,.086.171.257.257.342l.257.428c1.454,2.736,2.907,5.472,4.275,8.294.684,1.539,1.454,2.993,2.052,4.446l.342.855a5.94,5.94,0,0,1,.428,1.112L17.945,125.481l-6.669.086a4.124,4.124,0,0,0-4.1,4.19L7,167.294a11.3,11.3,0,0,0,4.446,9.063,160.557,160.557,0,0,0,30.012,17.7,4.069,4.069,0,0,1,2.223,2.651l5.985,20.778a4.207,4.207,0,0,0,4.019,3.078H77.713a4.286,4.286,0,0,0,4.1-3.164l2.138-8.208,38.477.171,2.052,8.038a4.211,4.211,0,0,0,4.1,3.164H152.7a4.207,4.207,0,0,0,4.019-3.078l8.807-30.44a3.936,3.936,0,0,1,.855-1.539c14.023-14.023,20.521-35.4,16.93-55.664Q182.8,127.149,182.029,124.455Z" transform="translate(0 -10.06)" />
				<path fill="rgba(47,165,231,0.3)" d="M61.81,135.355a6.755,6.755,0,1,1-6.755-6.755A6.825,6.825,0,0,1,61.81,135.355Z" transform="translate(-5.986 -17.297)" />
			</g>
		</svg>
	);
};

export const FontsIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="19.6" height="12.176" viewBox="0 0 19.6 12.176" {...props}>
			<path
				fill="currentColor"
				d="M-5.128-12h1.312L.2-.832l1.04.144V0h-3.9V-.688l1.408-.144L-2.1-3.376H-7.1L-7.944-.848l1.424.16V0h-3.6V-.688L-9.1-.832ZM-4.2-9.536l-.448-1.52L-5.08-9.488l-1.744,5.28h4.432Zm6.048,7.2A2.334,2.334,0,0,1,3.384-4.584a9.771,9.771,0,0,1,3.824-.744v-.5A3.963,3.963,0,0,0,7.04-7.112,1.192,1.192,0,0,0,6.456-7.8a2.576,2.576,0,0,0-1.168-.216,4.2,4.2,0,0,0-1.48.248,9.1,9.1,0,0,0-1.288.6l-.352-.7A3.907,3.907,0,0,1,2.9-8.32a7.994,7.994,0,0,1,1.28-.512,4.677,4.677,0,0,1,1.392-.224,4.025,4.025,0,0,1,1.72.3,1.818,1.818,0,0,1,.912.976,4.8,4.8,0,0,1,.28,1.808v5.28H9.48V-.1a5.83,5.83,0,0,1-1.488.24.853.853,0,0,1-.528-.12Q7.32-.1,7.32-.528V-1.12a7.591,7.591,0,0,1-1.256.9A3.035,3.035,0,0,1,4.52.176a2.866,2.866,0,0,1-1.912-.64A2.31,2.31,0,0,1,1.848-2.336ZM5-.768a2.648,2.648,0,0,0,1.072-.288,5.752,5.752,0,0,0,1.136-.688V-4.576A6.245,6.245,0,0,0,4.272-4a1.685,1.685,0,0,0-1,1.5,1.674,1.674,0,0,0,.464,1.32A1.847,1.847,0,0,0,5-.768Z"
				transform="translate(10.12 12)"
			/>
		</svg>
	);
};

export const DropboxIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="28px" height="26.25px" viewBox="0 0 28 26.25" {...props}>
			<path
				fill="#007ee5"
				d="M8.265,0L0,5.396l5.715,4.577l8.333-5.146L8.265,0z M0,14.549l8.265,5.398l5.783-4.828L5.715,9.973L0,14.549 z M14.048,15.119l5.784,4.828l8.265-5.398l-5.715-4.576L14.048,15.119z M28.097,5.396L19.832,0l-5.784,4.827l8.334,5.146 L28.097,5.396z M14.066,16.158l-5.801,4.812L5.783,19.35v1.817l8.283,4.967l8.282-4.967V19.35l-2.482,1.621L14.066,16.158z"
			/>
		</svg>
	);
};

export const GoogleDriveIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139 120.4" {...props}>
			<radialGradient
				id="a"
				cx="-254.81979"
				cy="705.83588"
				gradientTransform="matrix(2.827 1.6322 -1.6322 2.827 2092.1199 -1494.5786)"
				gradientUnits="userSpaceOnUse"
				r="82.978401"
			>
				<stop offset="0" stopColor="#4387fd" />
				<stop offset=".65" stopColor="#3078f0" />
				<stop offset=".9099" stopColor="#2b72ea" />
				<stop offset="1" stopColor="#286ee6" />
			</radialGradient>
			<radialGradient
				id="b"
				cx="-254.8174"
				cy="705.83691"
				gradientTransform="matrix(2.827 1.6322 -1.6322 2.827 2092.1199 -1494.5786)"
				gradientUnits="userSpaceOnUse"
				r="82.973"
			>
				<stop offset="0" stopColor="#ffd24d" />
				<stop offset="1" stopColor="#f6c338" />
			</radialGradient>
			<path d="m24.2 120.4-24.2-41.9 45.3-78.5 24.2 41.9z" fill="#0da960" />
			<path d="m24.2 120.4 24.2-41.9h90.6l-24.2 41.9z" fill="url(#a)" />
			<path d="m139 78.5h-48.4l-45.3-78.5h48.4z" fill="url(#b)" />
			<path d="m69.5 78.5h-21.1l10.5-18.3-34.7 60.2z" fill="#2d6fdd" />
			<path d="m90.6 78.5h48.4l-58.9-18.3z" fill="#e5b93c" />
			<path d="m58.9 60.2 10.6-18.3-24.2-41.9z" fill="#0c9b57" />
		</svg>
	);
};

export const OneDriveIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 27" {...props}>
			<g>
				<path
					d="M 10.5,21 C 10.5,17.688 13.188,15 16.5,15 C 16.502,15 16.505,15.001 16.508,15.001 C 16.704,10.827 20.153,7.5 24.375,7.5 C 27.304,7.5 29.861,9.103 31.218,11.478 C 32.161,10.86 33.289,10.5 34.5,10.5 C 37.812,10.5 40.5,13.188 40.5,16.5 C 40.5,16.758 40.483,17.012 40.452,17.261 C 42.99,17.43 45,19.544 45,22.125 C 45,24.816 42.816,27 40.125,27 L 16.5,27 C 13.188,27 10.5,24.312 10.5,21 Z M 0,18.75 C 0,15.678 2.312,13.143 5.291,12.792 C 5.264,12.532 5.25,12.268 5.25,12 C 5.25,7.86 8.61,4.5 12.75,4.5 C 13.947,4.5 15.079,4.781 16.083,5.281 C 17.705,2.145 20.978,0 24.75,0 C 29.879,0 34.088,3.969 34.471,9.001 C 33.724,9.003 33.003,9.116 32.322,9.323 L 31.709,9.558 L 31.057,8.804 C 29.358,7.076 26.992,6 24.375,6 C 19.975,6 16.283,9.033 15.271,13.121 L 15.197,13.634 L 14.993,13.654 C 11.572,14.352 9,17.377 9,21 C 9,22.366 9.365,23.647 10.003,24.75 L 6,24.75 C 2.688,24.75 0,22.062 0,18.75 Z"
					fill="#094ab1"
				/>
			</g>
		</svg>
	);
};

export const TeamAssetsLogoIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="58.953" height="58.955" viewBox="0 0 58.953 58.955" {...props}>
			<g transform="translate(-156.75 -278.75)">
				<g transform="translate(163.724 284.297)">
					<path
						fill="currentColor"
						d="M8.425,15.362A25.845,25.845,0,0,1,7.266,11.4c-.1-.52-.208-1.024-.3-1.544-.059-.327-.1-.668-.163-1.01-.03-.163-.045-.341-.074-.5v-.1c0-.03-.015-.074-.015-.1a1.146,1.146,0,0,1,.223.03l.134.015c.341.045.668.089,1.01.148.668.1,1.321.223,1.945.356a27.691,27.691,0,0,1,3.831,1.114.714.714,0,0,0,.5-1.336A27.889,27.889,0,0,0,10.34,7.285c-.638-.134-1.321-.267-2.019-.371-.341-.059-.7-.1-1.039-.148l-.148-.015a2.1,2.1,0,0,0-1.218.1A1.193,1.193,0,0,0,5.278,7.89a3.058,3.058,0,0,0,.03.549l.015.089c.03.178.045.356.074.535.045.341.1.7.163,1.039q.134.8.312,1.6a29.358,29.358,0,0,0,1.216,4.2.706.706,0,0,0,.668.46.72.72,0,0,0,.668-.995Z"
					/>
					<path
						fill="currentColor"
						d="M178.239,176.462a3.255,3.255,0,0,1-.579-1.782,9.741,9.741,0,0,0-2.66-5.746,5.1,5.1,0,0,0-2.777-1.277,5.859,5.859,0,0,0-6.37,5.924c.163,3.059,3.059,4.751,5.494,5.286a3.8,3.8,0,0,1,1.782.683.742.742,0,0,0,.52.208.708.708,0,0,0,.3-.059.922.922,0,0,0,.431-.98,2.956,2.956,0,0,0-.98-1.841c-.148-.163-.3-.327-.416-.475a.714.714,0,0,1-.148-.564.644.644,0,0,1,.371-.371,1.533,1.533,0,0,1,1.455.119,3.727,3.727,0,0,1,.653.7,3.914,3.914,0,0,0,1.247,1.158,2.633,2.633,0,0,0,.876.267.883.883,0,0,0,.95-.431.759.759,0,0,0-.149-.819Zm-2.747-2.034a2.965,2.965,0,0,0-2.9-.252,2.077,2.077,0,0,0-1.143,1.292,2.13,2.13,0,0,0,.356,1.737,3.615,3.615,0,0,0,.3.371c-.163-.045-.312-.074-.46-.1-1.945-.416-4.246-1.708-4.38-3.964a4.24,4.24,0,0,1,1.425-3.267,4.3,4.3,0,0,1,2.88-1.2c.148,0,.312.015.46.03a3.736,3.736,0,0,1,2.019.935,8.125,8.125,0,0,1,2.2,4.915c.015.1.03.208.045.327a3.483,3.483,0,0,0-.8-.824Z"
						transform="translate(-137.779 -138.051)"
					/>
					<path
						fill="currentColor"
						d="M47.063,42.863,46.376,41c-.286-.759-.6-1.517-.944-2.247L51.183,33a1.486,1.486,0,0,0,.3-1.689,1.507,1.507,0,0,0-1.473-.873l-9.742.716a26.867,26.867,0,0,0-7.51-5.553,1.969,1.969,0,0,0-.243-.114.675.675,0,0,0-.773.129L24.217,33.13a.694.694,0,0,0-.129.787l.1.2a26.85,26.85,0,0,0,5.565,7.542l-.715,9.761a1.5,1.5,0,0,0,.873,1.474,1.4,1.4,0,0,0,.629.143,1.507,1.507,0,0,0,1.059-.444l5.751-5.768c.73.343,1.488.658,2.232.93l1.86.687a.7.7,0,0,0,.715-.157l4.735-4.709a.648.648,0,0,0,.171-.713ZM41.527,47l-1.445-.544c-.858-.315-1.717-.687-2.546-1.088a.7.7,0,0,0-.787.129l-6.094,6.111a.129.129,0,0,1-.157.029c-.086-.043-.086-.1-.072-.129l.73-10.09a.723.723,0,0,0-.215-.558,25.137,25.137,0,0,1-5.408-7.113l6.824-6.827a25.474,25.474,0,0,1,7.139,5.4.675.675,0,0,0,.558.215l10.071-.744h0a.134.134,0,0,1,.129.072.129.129,0,0,1-.029.157l-6.094,6.1A.694.694,0,0,0,44,38.9c.4.83.773,1.689,1.1,2.576l.529,1.445Z"
						transform="translate(-15.963 -15.934)"
					/>
					<path
						fill="currentColor"
						d="M77.648,78.914a2.874,2.874,0,0,0-.848,2.041A2.824,2.824,0,0,0,77.648,83a2.874,2.874,0,0,0,2.041.848h0A2.824,2.824,0,0,0,81.731,83a2.887,2.887,0,1,0-4.082-4.082Zm3.246,3.246a1.7,1.7,0,0,1-1.205.5h0a1.654,1.654,0,0,1-1.205-.5,1.7,1.7,0,1,1,2.41,0Z"
						transform="translate(-60.685 -60.55)"
					/>
				</g>
				<path
					fill="none"
					fillRule="evenodd"
					stroke="currentColor"
					strokeWidth="1.5"
					transform="translate(-64.217 504.499)"
					d="M221.717-196.269A28.739,28.739,0,0,1,250.441-225a28.743,28.743,0,0,1,28.729,28.73,28.738,28.738,0,0,1-28.729,28.724A28.734,28.734,0,0,1,221.717-196.269Z"
				/>
			</g>
		</svg>
	);
};

export const TeamAssetsImageIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="46" height="30" viewBox="0 0 46 30" {...props}>
			<g transform="translate(-382 -290)">
				<g
					transform="translate(382 290)"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.2"
				>
					<rect width="46" height="30" rx="3" stroke="none" />
					<rect x="0.6" y="0.6" width="44.8" height="28.8" rx="2.4" fill="none" />
				</g>
				<g
					transform="translate(417 294)"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.2"
				>
					<circle cx="3" cy="3" r="3" stroke="none" />
					<circle cx="3" cy="3" r="2.4" fill="none" />
				</g>
				<path
					d="M1832.56,5595.407l.653-.915,14.6-18.66,12.441,18.66,6.639-9.118,6.868,9.118.7.915"
					transform="translate(-1449.066 -5276.2)"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.2"
				/>
			</g>
		</svg>

	);
};

export const TeamAssetsOtherIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="35.776" height="29.86" viewBox="0 0 35.776 29.86" {...props}>
			<g transform="translate(-487 -290)">
				<g transform="translate(482.9 271.022)">
					<path
						d="M4.732,42.719A.676.676,0,0,0,5.365,42V17.417a.676.676,0,0,0-.632-.717.676.676,0,0,0-.632.717V42A.676.676,0,0,0,4.732,42.719Z"
						transform="translate(0 2.278)"
						fill="currentColor"
					/>
					<path
						d="M8.951,228.5H4.88a.644.644,0,1,0,0,1.258H8.965a.714.714,0,0,0,.78-.629A.728.728,0,0,0,8.951,228.5Z"
						transform="translate(0 -180.92)"
						fill="currentColor"
					/>
					<path
						d="M61.151,228.5H57.08a.644.644,0,1,0,0,1.258h4.086a.714.714,0,0,0,.78-.629A.728.728,0,0,0,61.151,228.5Z"
						transform="translate(-44.664 -180.92)"
						fill="currentColor"
					/>
					<path
						d="M113.265,228.5H109.18a.644.644,0,1,0,0,1.258h4.086a.644.644,0,1,0,0-1.258Z"
						transform="translate(-89.242 -180.92)"
						fill="currentColor"
					/>
					<path
						d="M165.465,228.5H161.38a.644.644,0,1,0,0,1.258h4.086a.644.644,0,1,0,0-1.258Z"
						transform="translate(-133.905 -180.92)"
						fill="currentColor"
					/>
					<path
						d="M217.665,228.5H213.58a.644.644,0,1,0,0,1.258h4.086a.644.644,0,1,0,0-1.258Z"
						transform="translate(-178.569 -180.92)"
						fill="currentColor"
					/>
				</g>
				<g transform="translate(1)">
					<g
						transform="translate(491 304)"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.2"
					>
						<circle cx="3" cy="3" r="3" stroke="none" />
						<circle cx="3" cy="3" r="2.4" fill="none" />
					</g>
					<g
						transform="translate(499 296)"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.2"
					>
						<circle cx="3" cy="3" r="3" stroke="none" />
						<circle cx="3" cy="3" r="2.4" fill="none" />
					</g>
					<g
						transform="translate(507 304)"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.2"
					>
						<circle cx="3" cy="3" r="3" stroke="none" />
						<circle cx="3" cy="3" r="2.4" fill="none" />
					</g>
					<g
						transform="translate(515 296)"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.2"
					>
						<circle cx="3" cy="3" r="3" stroke="none" />
						<circle cx="3" cy="3" r="2.4" fill="none" />
					</g>
					<line x1="5" y2="5" transform="translate(495.5 300.5)" fill="none" stroke="currentColor" strokeWidth="1.2" />
					<line x2="5" y2="5" transform="translate(503.5 300.5)" fill="none" stroke="currentColor" strokeWidth="1.2" />
					<line x1="5" y2="5" transform="translate(511.5 300.5)" fill="none" stroke="currentColor" strokeWidth="1.2" />
				</g>
			</g>
		</svg>
	);
};

export const CheckIcon = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="15.213" height="11.268" viewBox="0 0 15.213 11.268" {...props}>
		<path
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeWidth="1.5px"
			d="M2640.009,518.006l6.242,4.794,6.79-8.487"
			transform="matrix(0.998, 0.0695, -0.072, 0.998, -2596.288, -696.418)"
		/>
	</svg>
);

export const CheckIcon2 = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" {...props}>
		<g>
			<path d="M2.91675 7.81658L5.36119 10.3055L11.4723 4.08325" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
			<path d="M2.91675 7.81658L5.36119 10.3055L11.4723 4.08325" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
		</g>
	</svg>
);

export const SmartFieldsIcon = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M17.0666 4.8L6.3999 18.24H15.9999L14.9332 27.2L25.5999 13.76H15.9999L17.0666 4.8Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const CustomizeIcon = props => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M16.1298 1.8356C16.3947 1.57068 16.7092 1.36054 17.0553 1.21716C17.4015 1.07379 17.7725 1 18.1471 1C18.5217 1 18.8927 1.07379 19.2389 1.21716C19.585 1.36054 19.8995 1.57068 20.1644 1.8356C20.4293 2.10051 20.6395 2.41501 20.7828 2.76114C20.9262 3.10727 21 3.47825 21 3.8529C21 4.22755 20.9262 4.59853 20.7828 4.94466C20.6395 5.29079 20.4293 5.60529 20.1644 5.87021L6.54759 19.487L1 21L2.51298 15.4524L16.1298 1.8356Z" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const CloseIcon = props => (
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M15 15L29 29" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M29 15L15 29" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<circle cx="22" cy="22" r="15" stroke="currentColor" strokeWidth="2" />
	</svg>
);

export const ClearIcon = props => (
	<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path id="Vector" d="M2.5 2.5L7.5 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path id="Vector_2" d="M7.5 2.5L2.5 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const DownloadIcon = props => (
	<svg width="18.8" height="18.8" viewBox="0 0 18.8 18.8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<defs>
		</defs>
		<g transform="translate(-19.6 -357.6)">
			<g transform="translate(17 355)" strokeWidth="0.8px">
				<path className="a" d="M21,15v4a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V15" fill="none" stroke="currentColor" />
				<path className="a" d="M7,10l5,5,5-5" fill="none" stroke="currentColor" />
				<line className="a" y1="12" transform="translate(12 3)" fill="none" stroke="currentColor" />
			</g>
		</g>
	</svg>
);

export const SharedIcon = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="19.841" height="16.415" viewBox="0 0 19.841 16.415" {...props}>
		<g id="Icon_feather-users" transform="translate(-1 -4)">
			<path id="Path_629" data-name="Path 629" d="M15.2,27.638V25.926A3.426,3.426,0,0,0,11.777,22.5H4.926A3.426,3.426,0,0,0,1.5,25.926v1.713" transform="translate(0 -7.723)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
			<path id="Path_630" data-name="Path 630" d="M14.351,7.926A3.426,3.426,0,1,1,10.926,4.5a3.426,3.426,0,0,1,3.426,3.426Z" transform="translate(-2.574)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
			<path id="Path_631" data-name="Path 631" d="M32.569,27.722V26.009A3.426,3.426,0,0,0,30,22.7" transform="translate(-12.229 -7.807)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
			<path id="Path_632" data-name="Path 632" d="M24,4.7a3.426,3.426,0,0,1,0,6.637" transform="translate(-9.654 -0.084)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
		</g>
	</svg>
);

export const NextIcon = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
		<circle cx="8" cy="8" r="7" fill="currentColor"/>
		<path d="M7 11L10 8.00369L7 5" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const XDarkLogo = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" {...props}>
		<path d="M28 40C34.6274 40 40 34.6274 40 28C40 21.3726 34.6274 16 28 16C21.3726 16 16 21.3726 16 28C16 34.6274 21.3726 40 28 40Z" fill="#22313E"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M33.5577 22.0655C33.49 21.9939 33.4084 21.9368 33.318 21.8977C33.2276 21.8586 33.1301 21.8382 33.0316 21.8378C32.9332 21.8381 32.8358 21.8584 32.7454 21.8973C32.655 21.9362 32.5734 21.9929 32.5055 22.0642L27.8087 26.9083L23.1138 22.0655C23.0457 21.994 22.9639 21.937 22.8733 21.8978C22.7827 21.8587 22.6851 21.8383 22.5864 21.8378C22.4874 21.838 22.3894 21.8582 22.2984 21.8974C22.2074 21.9365 22.1253 21.9937 22.0571 22.0655C21.9175 22.2125 21.8397 22.4074 21.8397 22.61C21.8397 22.8127 21.9175 23.0076 22.0571 23.1546L32.5068 33.9377C32.575 34.009 32.657 34.0656 32.7478 34.1041C32.8386 34.1426 32.9362 34.1621 33.0348 34.1615C33.133 34.1629 33.2304 34.1437 33.3208 34.1053C33.4111 34.0669 33.4925 34.01 33.5596 33.9384C33.6997 33.7913 33.7779 33.596 33.7779 33.3929C33.7779 33.1897 33.6997 32.9944 33.5596 32.8473L28.8692 28.0013L33.5596 23.1546C33.702 23.0076 33.7807 22.8105 33.7788 22.6058C33.7801 22.4036 33.7013 22.2091 33.5596 22.0649L33.5577 22.0655Z" fill="white"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M22.0448 33.9481C22.1099 34.0156 22.1879 34.0693 22.2742 34.106C22.3606 34.1426 22.4534 34.1615 22.5472 34.1615C22.641 34.1615 22.7338 34.1426 22.8201 34.106C22.9064 34.0693 22.9844 34.0156 23.0495 33.9481L25.5579 31.3619L24.5525 30.3241L22.0448 32.9103C21.9114 33.0501 21.837 33.2359 21.837 33.4292C21.837 33.6224 21.9114 33.8083 22.0448 33.9481Z" fill="#2FA5E7"/>
	</svg>
);

export const SuccessIcon = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" {...props}>
		<path d="M53 25.7143V28.0143C52.9969 33.4054 51.2513 38.651 48.0233 42.9689C44.7954 47.2867 40.2582 50.4455 35.0884 51.9741C29.9186 53.5026 24.3931 53.3191 19.3362 51.4508C14.2792 49.5825 9.96164 46.1296 7.0274 41.607C4.09317 37.0844 2.69948 31.7345 3.05419 26.3551C3.40891 20.9757 5.49302 15.8551 8.9957 11.757C12.4984 7.65886 17.232 4.80277 22.4905 3.61467C27.749 2.42658 33.2507 2.97015 38.175 5.16431" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
		<path d="M53 8.01465L28 33.0396L20.5 25.5396" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
	</svg>
);

export const SpinnerIcon = props => (
	<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z" />
	</svg>
);

export const TemplatesIcon = props => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path fillRule="evenodd" clipRule="evenodd" d="M7 2C5.34315 2 4 3.34315 4 5V17C4 18.6569 5.34315 20 7 20H10V18H7C6.44772 18 6 17.5523 6 17V5C6 4.44772 6.44772 4 7 4H16C16.5523 4 17 4.44772 17 5V11H19V5C19 3.34315 17.6569 2 16 2H7Z" fill="currentColor"/>
		<path d="M21 21.9998V20.9998C21 20.4693 20.7893 19.9606 20.4142 19.5855C20.0391 19.2105 19.5304 18.9998 19 18.9998H15C14.4696 18.9998 13.9609 19.2105 13.5858 19.5855C13.2107 19.9606 13 20.4693 13 20.9998V21.9998" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M17 17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<line x1="9" y1="7" x2="14" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
		<line x1="9" y1="11" x2="12" y2="11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
	</svg>
);

export const DocumentsIcon = props => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M12 3V9H17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M6.4749 1.8999C5.78273 1.8999 5.12481 2.18298 4.64421 2.67731C4.16455 3.17068 3.8999 3.83398 3.8999 4.5199V17.4799C3.8999 18.1658 4.16455 18.8291 4.64421 19.3225C5.12481 19.8168 5.78273 20.0999 6.4749 20.0999H10V18.0999H6.4749C6.33164 18.0999 6.18835 18.0416 6.0782 17.9283C5.96713 17.8141 5.8999 17.6533 5.8999 17.4799V4.5199C5.8999 4.34652 5.96713 4.18572 6.0782 4.07147C6.18835 3.95818 6.33164 3.8999 6.4749 3.8999H11.5649L16.4999 8.97589V11H18.4999V8.5699C18.4999 8.30956 18.3984 8.05949 18.2169 7.87282L12.7044 2.20282C12.5161 2.00916 12.2575 1.8999 11.9874 1.8999H6.4749Z" fill="currentColor"/>
		<path d="M21 21.9998V20.9998C21 20.4693 20.7893 19.9606 20.4142 19.5855C20.0391 19.2105 19.5304 18.9998 19 18.9998H15C14.4696 18.9998 13.9609 19.2105 13.5858 19.5855C13.2107 19.9606 13 20.4693 13 20.9998V21.9998" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M17 17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const AssetsIcon = props => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path fillRule="evenodd" clipRule="evenodd" d="M9.3 4L11.1 6.66667H19.2C19.6774 6.66667 20.1352 6.85397 20.4728 7.18737C20.8104 7.52076 21 7.97295 21 8.44444V11H19V8.66667H11.1C10.4354 8.66667 9.81415 8.33649 9.4423 7.78561L8.23701 6H5V18H10V20H4.8C4.32261 20 3.86477 19.8127 3.52721 19.4793C3.18964 19.1459 3 18.6937 3 18.2222V5.77778C3 5.30628 3.18964 4.8541 3.52721 4.5207C3.86477 4.1873 4.32261 4 4.8 4H9.3Z" fill="currentColor"/>
		<path d="M21 21.9998V20.9998C21 20.4693 20.7893 19.9606 20.4142 19.5855C20.0391 19.2105 19.5304 18.9998 19 18.9998H15C14.4696 18.9998 13.9609 19.2105 13.5858 19.5855C13.2107 19.9606 13 20.4693 13 20.9998V21.9998" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M17 17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const XIcon = props => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const VoucherIcon = props => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_229_11786)">
			<path d="M8.57122 12.6113C8.69122 12.6113 8.81123 12.5656 8.90276 12.474C9.0858 12.291 9.0858 11.994 8.90276 11.811L8.68195 11.5902C8.4989 11.4071 8.20224 11.4071 8.01888 11.5902C7.83583 11.7732 7.83583 12.0702 8.01888 12.2532L8.23969 12.474C8.33121 12.5656 8.45121 12.6113 8.57122 12.6113Z" fill="currentColor"/>
			<path d="M10.6909 13.5996L10.4153 13.3238C10.2323 13.1407 9.93532 13.1407 9.75228 13.3238C9.56923 13.5068 9.56923 13.8035 9.75228 13.9868L10.0278 14.2624C10.1196 14.3539 10.2393 14.3997 10.3593 14.3997C10.4793 14.3997 10.5993 14.3539 10.6909 14.2624C10.8739 14.0793 10.8739 13.7827 10.6909 13.5996Z" fill="currentColor"/>
			<path d="M11.4964 15.0678C11.3134 15.2509 11.3134 15.5479 11.4964 15.7309L11.8055 16.0397C11.8971 16.1312 12.0171 16.177 12.1371 16.177C12.2568 16.177 12.3768 16.1312 12.4683 16.0397C12.6513 15.8567 12.6513 15.56 12.4683 15.377L12.1595 15.0678C11.9764 14.8848 11.6795 14.8848 11.4964 15.0678Z" fill="currentColor"/>
			<path d="M23.3683 6.3929L21.8185 4.84307C21.7305 4.75507 21.6114 4.70579 21.4869 4.70579C21.3628 4.70579 21.2434 4.75507 21.1554 4.84307C20.8898 5.10869 20.5365 5.25493 20.1608 5.25493C19.7851 5.25493 19.4318 5.10869 19.1662 4.84307C18.6177 4.29457 18.6177 3.40206 19.1662 2.85356C19.3493 2.67051 19.3493 2.37386 19.1662 2.19049L17.6081 0.632345C16.7648 -0.210888 15.3926 -0.210888 14.5497 0.632345L6.61818 8.56386C6.53018 8.65187 6.4809 8.77123 6.4809 8.8954L6.48058 10.0519H5.32405C5.19989 10.0519 5.08052 10.1015 4.99252 10.1895L0.633307 14.5487C0.22497 14.9571 0 15.5001 0 16.0778C0 16.6557 0.22497 17.1988 0.633307 17.6071L2.19145 19.1652C2.37449 19.3486 2.67147 19.3486 2.85451 19.1652C3.12012 18.8996 3.47342 18.7534 3.84911 18.7534C4.22513 18.7534 4.5781 18.8996 4.84403 19.1652C5.10964 19.4312 5.25589 19.7845 5.25589 20.1602C5.25589 20.5359 5.10964 20.8892 4.84403 21.1548C4.75603 21.2428 4.70643 21.3618 4.70643 21.4863C4.70643 21.6105 4.75603 21.7298 4.84403 21.8178L6.39385 23.3677C6.81531 23.7891 7.36925 24 7.92287 24C8.47682 24 9.03044 23.7891 9.45222 23.3677L13.8114 19.0081C13.8994 18.9204 13.9487 18.8011 13.9487 18.6766V17.5201H15.1056C15.2297 17.5201 15.3491 17.4708 15.4368 17.3828L18.2714 14.5481C18.4545 14.3651 18.4545 14.0684 18.2714 13.8854C18.0884 13.7023 17.7918 13.7023 17.6084 13.8854L14.9113 16.5824H13.4799C13.221 16.5824 13.0111 16.7924 13.0111 17.0512V18.4827L8.78915 22.7046C8.31169 23.1824 7.53438 23.1824 7.05692 22.7046L5.80535 21.4533C6.05784 21.0732 6.19353 20.6271 6.19353 20.1602C6.19353 19.5339 5.94968 18.9454 5.50678 18.5025C5.0642 18.0596 4.47538 17.8158 3.84944 17.8158C3.38254 17.8158 2.93644 17.9514 2.55594 18.2039L1.29637 16.944C0.818914 16.4666 0.818914 15.6893 1.29637 15.2118L5.5183 10.9896H6.94972C7.20829 10.9896 7.41822 10.78 7.41822 10.5211L7.41854 9.08964L15.2124 1.29541C15.6902 0.817635 16.4675 0.817635 16.945 1.29541L18.2052 2.55563C17.6033 3.4651 17.7028 4.70547 18.5031 5.50614C18.946 5.94872 19.5349 6.19257 20.1608 6.19257C20.6277 6.19257 21.0738 6.05688 21.454 5.80439L22.7055 7.05596C23.183 7.53342 23.183 8.31073 22.7055 8.78819L20.5906 10.9028C20.4075 11.0859 20.4075 11.3829 20.5906 11.5659C20.774 11.749 21.0706 11.749 21.2536 11.5659L23.3683 9.45126C24.2115 8.60803 24.2115 7.23613 23.3683 6.3929Z" fill="currentColor"/>
			<path d="M14.1058 6.16531C13.8562 6.23475 13.7103 6.49332 13.7797 6.74261L15.3004 12.2065C15.3584 12.4139 15.5465 12.5496 15.752 12.5496C15.7936 12.5496 15.8358 12.5441 15.8781 12.5323C16.1274 12.4628 16.2733 12.2046 16.2038 11.955L14.6831 6.4914C14.6137 6.24179 14.3551 6.09618 14.1058 6.16531Z" fill="currentColor"/>
			<path d="M16.7322 7.91257C16.184 8.46075 16.184 9.35327 16.7322 9.90177C17.0064 10.1757 17.3668 10.313 17.7268 10.313C18.0871 10.313 18.4471 10.1757 18.7214 9.90145C19.2699 9.35327 19.2699 8.46075 18.7214 7.91257C18.4558 7.64664 18.1025 7.5004 17.7268 7.5004C17.3511 7.5004 16.9978 7.64664 16.7322 7.91257ZM18.0583 9.2387C17.8756 9.42143 17.578 9.42143 17.3952 9.2387C17.2125 9.05566 17.2125 8.75837 17.3952 8.57532C17.4839 8.487 17.6017 8.43803 17.7268 8.43803C17.8522 8.43803 17.97 8.487 18.0583 8.57532C18.2414 8.75837 18.2414 9.05566 18.0583 9.2387Z" fill="currentColor"/>
			<path d="M13.2905 8.07737C13.0249 7.81176 12.6716 7.66519 12.2959 7.66519C11.9202 7.66519 11.5669 7.81176 11.3013 8.07737C10.7528 8.62555 10.7528 9.51806 11.3013 10.0666C11.5755 10.3408 11.9355 10.4778 12.2959 10.4778C12.6559 10.4778 13.0162 10.3405 13.2905 10.0666C13.8387 9.51806 13.8387 8.62555 13.2905 8.07737ZM12.6274 9.4035C12.4447 9.58623 12.1471 9.58623 11.9643 9.4035C11.7813 9.22045 11.7813 8.92316 11.9643 8.74011C12.0527 8.65179 12.1704 8.60283 12.2959 8.60283C12.421 8.60283 12.5388 8.65179 12.6274 8.74011C12.8101 8.92316 12.8101 9.22045 12.6274 9.4035Z" fill="currentColor"/>
			<path d="M7.35589 13.7277C7.17284 13.5446 6.87619 13.5446 6.69282 13.7277L5.1014 15.3191C4.91835 15.5022 4.91835 15.7988 5.1014 15.9819C5.19292 16.0734 5.31293 16.1191 5.43293 16.1191C5.55294 16.1191 5.67294 16.0734 5.76447 15.9819L7.35589 14.3904C7.53894 14.2074 7.53894 13.9107 7.35589 13.7277Z" fill="currentColor"/>
			<path d="M6.89191 17.5779C7.01192 17.5779 7.13193 17.5321 7.22345 17.4406L8.81487 15.8492C8.99792 15.6661 8.99792 15.3692 8.81487 15.1861C8.63182 15.0031 8.33485 15.0031 8.15181 15.1861L6.56038 16.7775C6.37733 16.9606 6.37733 17.2575 6.56038 17.4406C6.6519 17.5321 6.77191 17.5779 6.89191 17.5779Z" fill="currentColor"/>
			<path d="M8.35041 19.0366C8.47041 19.0366 8.59042 18.9909 8.68195 18.8993L10.2734 17.3079C10.4564 17.1249 10.4564 16.8279 10.2734 16.6448C10.0903 16.4618 9.79335 16.4618 9.6103 16.6448L8.01888 18.2363C7.83583 18.4193 7.83583 18.7163 8.01888 18.8993C8.11072 18.9909 8.2304 19.0366 8.35041 19.0366Z" fill="currentColor"/>
			<path d="M19.4307 12.2575C19.3072 12.2575 19.1862 12.3074 19.0992 12.3948C19.0115 12.4818 18.9619 12.6028 18.9619 12.7263C18.9619 12.8495 19.0115 12.9705 19.0992 13.0575C19.1862 13.1449 19.3072 13.1948 19.4307 13.1948C19.5539 13.1948 19.6749 13.1449 19.7619 13.0575C19.8493 12.9705 19.8992 12.8495 19.8992 12.7263C19.8992 12.6028 19.8493 12.4818 19.7619 12.3948C19.6749 12.3074 19.5539 12.2575 19.4307 12.2575Z" fill="currentColor"/>
		</g>
		<defs>
			<clipPath id="clip0_229_11786">
				<rect width="24.0006" height="24" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

export const VoucherIconColored = props => (
	<svg fontSize="16" version="1.1" overflow="visible" width="100.84pt" height="100.839pt" viewBox="174.03 -780.877 100.84 100.839" fill="none" fillRule="evenodd" stroke="black" strokeWidth="0.501" strokeLinejoin="bevel" strokeMiterlimit="10" fontFamily="Times New Roman" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="Page background" transform="scale(1 -1)"/>
		<g id="Layer 1" transform="scale(1 -1)">
			<g id="Group" fillRule="nonzero" strokeLinejoin="miter" stroke="none" strokeWidth="0.197">
				<path d="M 250.274,779.956 C 246.38,776.06 240.064,776.06 236.169,779.956 C 236.167,779.958 236.165,779.96 236.163,779.962 C 235.822,780.304 235.272,780.314 234.93,779.973 L 174.934,719.977 C 174.593,719.635 174.603,719.085 174.944,718.743 C 174.947,718.741 174.949,718.739 174.951,718.737 C 178.846,714.842 178.846,708.527 174.951,704.632 C 174.753,704.435 174.55,704.248 174.341,704.072 C 173.953,703.743 173.923,703.156 174.282,702.796 L 196.789,680.289 C 197.149,679.931 197.736,679.96 198.065,680.348 C 198.241,680.557 198.428,680.761 198.625,680.958 C 202.52,684.853 208.835,684.853 212.73,680.958 C 212.732,680.956 212.734,680.954 212.736,680.952 C 213.078,680.61 213.627,680.6 213.969,680.941 L 273.965,740.937 C 274.307,741.279 274.297,741.829 273.955,742.171 C 273.952,742.173 273.95,742.175 273.949,742.177 C 270.053,746.072 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.666 274.559,756.842 C 274.947,757.171 274.977,757.758 274.618,758.118 L 252.11,780.625 C 251.75,780.984 251.163,780.954 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 Z" fill="#e9f1f5" markerStart="none" markerEnd="none"/>
				<path d="M 274.559,756.842 C 274.947,757.171 274.977,757.758 274.617,758.117 L 252.11,780.625 C 251.75,780.985 251.163,780.955 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 C 249.277,778.959 248.121,778.218 246.888,777.731 L 266.501,758.117 C 266.861,757.758 266.831,757.171 266.442,756.842 C 266.233,756.666 266.03,756.479 265.832,756.282 C 261.938,752.387 261.938,746.072 265.832,742.177 L 265.838,742.171 C 266.18,741.828 266.18,741.269 265.839,740.927 L 208.409,683.498 C 209.991,683.049 211.484,682.204 212.73,680.958 L 212.736,680.952 C 213.077,680.61 213.627,680.6 213.969,680.941 L 273.965,740.937 C 274.306,741.279 274.296,741.829 273.955,742.171 C 273.952,742.172 273.95,742.175 273.949,742.177 C 270.053,746.072 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.666 274.559,756.842 Z" fill="#2e3f4f" markerStart="none" markerEnd="none"/>
				<path d="M 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 C 246.38,776.06 240.064,776.06 236.169,779.956 C 236.167,779.958 236.165,779.96 236.163,779.962 C 235.822,780.304 235.272,780.314 234.93,779.973 L 205.517,750.56 L 244.553,711.524 L 273.965,740.937 C 274.307,741.279 274.297,741.829 273.955,742.17 C 273.952,742.172 273.95,742.175 273.949,742.177 C 270.053,746.071 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.665 274.559,756.842 C 274.947,757.17 274.977,757.757 274.618,758.117 L 252.11,780.625 C 251.751,780.984 251.163,780.954 250.835,780.566 Z" fill="#62c5fd" markerStart="none" markerEnd="none"/>
				<path d="M 274.559,756.842 C 274.947,757.171 274.977,757.758 274.617,758.117 L 252.11,780.625 C 251.75,780.985 251.163,780.955 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 C 249.277,778.959 248.121,778.218 246.888,777.731 L 265.868,758.75 C 266.549,758.07 266.527,756.974 265.845,756.294 C 265.841,756.291 265.837,756.286 265.833,756.282 C 261.938,752.387 261.938,746.072 265.833,742.177 L 265.839,742.171 C 266.18,741.829 266.19,741.279 265.849,740.937 L 240.494,715.582 L 244.553,711.524 L 273.955,740.928 C 274.298,741.27 274.297,741.829 273.955,742.171 L 273.949,742.177 C 270.053,746.072 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.666 274.559,756.842 Z" fill="#2fa5e7" markerStart="none" markerEnd="none"/>
				<path d="M 236.708,742.445 C 233.192,738.929 227.471,738.929 223.955,742.445 C 220.439,745.96 220.439,751.681 223.955,755.197 C 227.471,758.713 233.192,758.713 236.708,755.197 C 240.223,751.681 240.223,745.96 236.708,742.445 Z M 227.632,751.521 C 226.143,750.032 226.143,747.61 227.632,746.121 C 229.12,744.633 231.542,744.633 233.031,746.121 C 234.519,747.61 234.519,750.032 233.031,751.521 C 231.542,753.009 229.12,753.009 227.632,751.521 Z" fill="#FFD508" markerStart="none" markerEnd="none"/>
				<path d="M 261.672,742.445 C 258.156,738.929 252.435,738.929 248.919,742.445 C 245.403,745.96 245.403,751.681 248.919,755.197 C 252.435,758.713 258.156,758.713 261.672,755.197 C 265.188,751.681 265.188,745.96 261.672,742.445 Z M 252.596,751.521 C 251.107,750.032 251.107,747.61 252.596,746.121 C 254.085,744.633 256.507,744.633 257.995,746.121 C 259.484,747.61 259.484,750.032 257.995,751.521 C 256.507,753.009 254.085,753.009 252.596,751.521 Z" fill="#FFD508" markerStart="none" markerEnd="none"/>
				<path d="M 242.814,727.856 C 241.377,727.856 240.213,729.02 240.213,730.456 L 240.213,767.186 C 240.213,768.622 241.378,769.786 242.814,769.786 C 244.249,769.786 245.413,768.622 245.413,767.186 L 245.413,730.456 C 245.413,729.02 244.249,727.856 242.814,727.856 Z" fill="#FFD508" markerStart="none" markerEnd="none"/>
				<path d="M 211.928,729.452 L 189.603,707.127 C 188.524,706.048 186.775,706.048 185.696,707.127 C 184.617,708.205 184.617,709.955 185.696,711.034 L 208.021,733.359 C 209.099,734.437 210.849,734.437 211.928,733.359 C 213.006,732.28 213.006,730.53 211.928,729.452 Z" fill="#62c5fd" markerStart="none" markerEnd="none"/>
				<path d="M 219.64,721.74 L 197.315,699.415 C 196.236,698.336 194.486,698.336 193.408,699.415 C 192.329,700.494 192.329,702.243 193.408,703.322 L 215.733,725.647 C 216.811,726.725 218.561,726.725 219.64,725.647 C 220.718,724.568 220.718,722.818 219.64,721.74 Z" fill="#62c5fd" markerStart="none" markerEnd="none"/>
				<path d="M 227.351,714.028 L 205.027,691.703 C 203.948,690.624 202.198,690.624 201.12,691.703 C 200.041,692.782 200.041,694.531 201.12,695.61 L 223.445,717.935 C 224.523,719.013 226.272,719.013 227.351,717.935 C 228.43,716.856 228.43,715.107 227.351,714.028 Z" fill="#62c5fd" markerStart="none" markerEnd="none"/>
				<g id="Group_1" fill="#FFD508">
					<path d="M 257.581,693.047 L 250.736,699.891 C 249.554,701.073 249.554,702.989 250.736,704.171 C 251.918,705.353 253.833,705.353 255.015,704.171 L 261.86,697.326 C 263.042,696.144 263.042,694.229 261.86,693.047 C 260.678,691.865 258.762,691.865 257.581,693.047 Z" markerStart="none" markerEnd="none"/>
					<path d="M 268.422,710.854 L 258.742,710.854 C 257.071,710.854 255.717,712.209 255.717,713.88 C 255.717,715.551 257.071,716.906 258.742,716.906 L 268.422,716.906 C 270.093,716.906 271.447,715.551 271.447,713.88 C 271.447,712.209 270.093,710.854 268.422,710.854 Z" markerStart="none" markerEnd="none"/>
					<path d="M 244.052,686.484 L 244.052,696.164 C 244.052,697.835 242.698,699.19 241.026,699.19 C 239.355,699.19 238,697.835 238,696.164 L 238,686.484 C 238,684.813 239.355,683.459 241.026,683.459 C 242.698,683.459 244.052,684.813 244.052,686.484 Z" markerStart="none" markerEnd="none"/>
					<path d="M 187.039,763.588 L 193.884,756.744 C 195.066,755.562 196.981,755.562 198.163,756.744 C 199.345,757.925 199.345,759.841 198.163,761.023 L 191.318,767.867 C 190.137,769.049 188.221,769.049 187.039,767.867 C 185.857,766.685 185.857,764.769 187.039,763.588 Z" markerStart="none" markerEnd="none"/>
					<path d="M 204.847,774.429 L 204.847,764.749 C 204.847,763.078 206.202,761.724 207.873,761.724 C 209.544,761.724 210.899,763.078 210.899,764.749 L 210.899,774.429 C 210.899,776.1 209.544,777.455 207.873,777.455 C 206.202,777.455 204.847,776.1 204.847,774.429 Z" markerStart="none" markerEnd="none"/>
					<path d="M 180.477,750.06 L 190.157,750.06 C 191.828,750.06 193.183,748.705 193.183,747.034 C 193.183,745.363 191.828,744.008 190.157,744.008 L 180.477,744.008 C 178.806,744.008 177.452,745.363 177.452,747.034 C 177.452,748.705 178.806,750.06 180.477,750.06 Z" markerStart="none" markerEnd="none"/>
				</g>
			</g>
		</g>
	</svg>
);

export const SortArrow = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path d="M9.99992 3.99995L9.99992 15.9999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M13 12.9999L10 15.9999L7 12.9999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	);
};

export const IconInvite = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<path d="M17.5003 2.5L9.16699 10.8333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M17.9719 2.66518C18.0354 2.48388 17.9894 2.28227 17.8536 2.14645C17.7177 2.01063 17.5161 1.96462 17.3348 2.02807L2.33482 7.27807C2.14132 7.3458 2.00877 7.52478 2.00042 7.72962C1.99206 7.93446 2.10959 8.12364 2.29693 8.20691L8.8712 11.1288L11.7931 17.7031C11.8764 17.8904 12.0655 18.0079 12.2704 17.9996C12.4752 17.9912 12.6542 17.8587 12.7219 17.6652L17.9719 2.66518Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	);
};

export const IconAddUsers = props => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M21 18.3333C21 17.4493 20.6839 16.6014 20.1213 15.9763C19.5587 15.3512 18.7956 15 18 15H12C11.2044 15 10.4413 15.3512 9.87868 15.9763C9.31607 16.6014 9 17.4493 9 18.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6C13.3431 6 12 7.34315 12 9C12 10.6569 13.3431 12 15 12Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M6 9V15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M3 12H9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export const IconNoPackage = props => {
	return (
		<img alt='' src={NoPackageImage} {...props} />
	);
};

export const IconEssential = props => {
	return (
		<img alt='Essential' src={EssentialImage} {...props} />
	);
};

export const IconScale = props => {
	return (
		<img alt='Scale' src={ScaleImage} {...props} />
	);
};

export const IconPGD = props => {
	return (
		<img alt='Photo &amp; Graphic Designer+' src={PGDImage} {...props} />
	);
};	

export const IconDP = props => {
	return (
		<img alt='Designer Pro+' src={DPImage} {...props} />
	);
};	

export const IconWD = props => {
	return (
		<img alt='Web Designer+' src={WDImage} {...props} />
	);
};

export const IconPGDPerpetual = props => {
	return (
		<img alt='Photo &amp; Graphic Designer+' src={PGDPerpetualImage} {...props} />
	);
};	

export const IconDPPerpetual = props => {
	return (
		<img alt='Designer Pro+' src={DPPerpetualImage} {...props} />
	);
};	

export const IconWDPerpetual = props => {
	return (
		<img alt='Web Designer+' src={WDPerpetualImage} {...props} />
	);
};

export const WeAcceptIcon = props => {
	return (
		<img alt='' src={WeAcceptImage} {...props} />
	);
};

export const WeAcceptEurIcon = props => {
	return (
		<img alt='' src={WeAcceptEurImage} {...props} />
	);
};

export const IconAddonAI = props => {
	return (
		<img alt='AI' src={AddonAI} {...props} />
	);
};	

export const IconAddonHosting = props => {
	return (
		<img alt='Hosting' src={AddonHosting} {...props} />
	);
};	

export const IconAddonCloudStorage = props => {
	return (
		<img alt='Cloud Storage' src={AddonCloudStorage} {...props} />
	);
};	

export const IconAddonDesignServices = props => {
	return (
		<img alt='Design Services' src={AddonDesignServices} {...props} />
	);
};	

export const IconAddonMLS = props => {
	return (
		<img alt='MLS Connect' src={AddonMLS} {...props} />
	);
};

export const IconMlsIdDone = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props}>
			<path d="M4.66602 10.4L8.09459 14L16.666 5" stroke="currentColor" strokeOpacity="0.75" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	);
};

export const IconTextFieldStatus = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props}>
			<path d="M4.66602 10.4L8.09459 14L16.666 5" stroke="currentColor" strokeOpacity="0.75" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	);
};

export const IconMlsIdAdd = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props}>
			<line x1="4.16602" y1="10" x2="17.166" y2="10" stroke="currentColor" strokeOpacity="0.75" strokeLinecap="round"/>
			<line x1="10.666" y1="3.5" x2="10.666" y2="16.5" stroke="currentColor" strokeOpacity="0.75" strokeLinecap="round"/>
		</svg>
	);
};

export const CheckIconRounded = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
			<g id="Group_2424" data-name="Group 2424" transform="translate(-1245 -257)">
				<circle id="Ellipse_57" data-name="Ellipse 57" cx="10" cy="10" r="10" transform="translate(1245 257)" fill="currentColor" />
				<path id="Path_2416" data-name="Path 2416" d="M9742,418.76l2.055,2.608,5.15-5.151" transform="translate(-8490.603 -151.744)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
			</g>
		</svg>
	);
};

export const UpdateSeatsIcon = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21.427" height="18.108" viewBox="0 0 21.427 18.108" {...props}>
			<g id="refresh" transform="translate(0 -39.691)">
				<path id="Path_2460" data-name="Path 2460" d="M6.359,50.024a.527.527,0,0,0-.4-.873H4.607c-.009-.134-.014-.269-.014-.405a6.117,6.117,0,0,1,10.314-4.453l1.91-2.234A9.054,9.054,0,0,0,1.659,48.745c0,.136,0,.271.009.405H.528a.527.527,0,0,0-.4.873L2.7,52.976l.541.62,1.941-2.226Z" fill="currentColor" />
				<path id="Path_2461" data-name="Path 2461" d="M137.2,163.757l-1.92-2.2-1.195-1.37-1.706,1.956-1.409,1.616a.527.527,0,0,0,.4.873h1.353a6.116,6.116,0,0,1-9.85,4.406l-1.91,2.234a9.054,9.054,0,0,0,14.7-6.641H136.8A.527.527,0,0,0,137.2,163.757Z" transform="translate(-115.903 -115.456)" fill="currentColor" />
			</g>
		</svg>
	);
};


// WEBPACK FOOTER //
// ./src/theme/icons.js